import {AfterViewInit, Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges} from '@angular/core';

declare let $: any;

@Directive({
    selector: '[appSelectorTwo]'
})
export class SelectorTwoDirective implements AfterViewInit, OnChanges, OnDestroy {
    @Input() value: any;
    @Output() onChange = new EventEmitter<string>();
    private element: any;
    private select2: any;

    constructor(private el: ElementRef) {
        this.element = $(el.nativeElement);
    }

    ngAfterViewInit() {
        this.el.nativeElement.style.width = '100%';
        this.initializeSelect2();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value.currentValue !== undefined) {
            this.element.val(this.value).trigger('change');
        }
    }

    ngOnDestroy() {
        if (this.select2) {
            this.select2.each((i, item) => {
                $(item).select2('destroy');
            });
        }
    }

    private initializeSelect2() {
        this.select2 = this.element.select2();
        this.select2.on('select2:select', (event) => {
            const selectedItem = event.params.data;
            this.onChange.emit(selectedItem.id);
        });
    }

}
